import { createContext } from 'react';
import type { Dispatch } from 'react';
import type { SetTaggedMomentEditParams, TaggedMomentState, SaveTaggedMomentFn } from './interfaces';

export const SetTaggedMomentEditParamsContext = createContext<SetTaggedMomentEditParams | null>(null);

export const TaggedMomentFormStateContext = createContext<TaggedMomentState.Value | null>(null);
export const TaggedMomentFormDispatchContext = createContext<Dispatch<TaggedMomentState.Action> | null>(null);
export const SaveTaggedMomentContext = createContext<SaveTaggedMomentFn | null>(null);
export const IsSavingTaggedMomentContext = createContext<boolean>(false);
